import { gql } from '@apollo/client';

export const fetchCustomerContactForEntitlement = gql`
  query fetchCustomerContactForEntitlement($id: String) {
    entitlementDetails(id: $id) {
      endCustomerContacts {
        accountId
        email
        name
        picture
      }
    }
  }
`;
